"use client";
import { Button, makeStyles, tokens } from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import { ClientRoutes } from "../models/ClientRoutes";
import { useCreateChapter } from "../hooks/useChapter";
import { ChapterFormData, CreateChapterRequest } from "../models/Chapter";
import ChapterForm from "../components/ChapterForm";
import { useTranslation } from "react-i18next";

const useClasses = makeStyles({
  root: {
    overflow: "hidden",
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    height: "100%",
    padding: tokens.spacingVerticalM,
  },
  buttons: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    padding: tokens.spacingVerticalM,
  },
});

function CreateChapterPage() {
  const classes = useClasses();
  const navigate = useNavigate();
  const { mutateAsync: createChapter, isPending } = useCreateChapter();
  const { t } = useTranslation();

  async function onFormSubmit(formData: ChapterFormData) {
    const createRequest: CreateChapterRequest = {
      title: formData.title,
      collectionTitle: formData.collectionTitle?.id ?? "",
      KMACollaborationVariant: formData.KMACollaborationVariant?.id ?? null,
      rootNode: formData.rootNode?.id ?? "",
      imageId: formData.imageId,
      chapterNavigationConfig: formData.chapterNavigationConfig,
    };

    const createdChapter = await createChapter(createRequest);

    navigate(`${ClientRoutes.Chapters}/${createdChapter.id}`);
  }

  return (
    <div className={classes.root}>
      <h1>{t("createChapter")}</h1>
      <ChapterForm
        isLoading={isPending}
        onSubmit={onFormSubmit}
        isRefetching={isPending}
      />
      <div className={classes.buttons}>
        <Button onClick={() => navigate(ClientRoutes.Chapters)}>
          Tillbaka
        </Button>
      </div>
    </div>
  );
}

export default CreateChapterPage;
